import { Navigate } from "react-router-dom";
import { getUser } from "@api/useAuth";
import { getDefaultRouteForUser } from "@utils";
import { getAccessToken } from "@utils/cookies";

export default function PublicRoute({ children }) {
  const accessToken = getAccessToken();
  const user = getUser();

  // If user is logged in, redirect to appropriate page
  if (accessToken && user) {
    return <Navigate to={getDefaultRouteForUser(user)} replace />;
  }

  return children;
}
